exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.ui-options {\n    overflow-y: auto;\n}\n\n", ""]);
